import {Col, Icon, Menu as MenuAntd, Row, Typography} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import React from "react";
import {observer} from "mobx-react";
import _ from "lodash";
import "./style.scss";
// store
import Store from "../../../../stores";
// service
import LabelMenuRoute from "./labelMenuRoute";
import {useHookDealerOrService} from "./helper";

export default React.memo(
    observer(function Menu({toggle}: IProps) {
        const {t} = useTranslation("common");
        const {handleSwitchDealerOrService, click, selectedItem, isDealerOrService} =
            useHookDealerOrService(toggle);

        const menuItems = _.isEqual(isDealerOrService, "dealer")
    ? [
        { key: "/", label: <a href="/">{t("Главная")}</a> },
        { key: "/numbers", label: <a href="/numbers">{t("База номеров")}</a> },
        { key: "/profile", label: <a href="/profile">{t("Профиль")}</a> },
        { key: "/reservation", label: <a href="/reservation">{t("Брони и активации")}</a> },
        { key: "/bonus", label: <a href="/bonus">{t("Бонусы")}</a> },
        { key: "/history", label: <a href="/history">{t("История операций")}</a> },
        { key: "https://disk.yandex.ru/d/upRoHABSpyghRQ", label: <a href="https://disk.yandex.ru/d/upRoHABSpyghRQ" target="_blank" rel="noopener noreferrer">{t("Рекламный контент")}</a> }
    ]
    .concat(
        Store.user?.level?.level !== 2 ? [{ key: "/dealers", label: <a href="/dealers">{t("Дилеры")}</a> }] : []
    )
    .concat([
        { key: "/deliveries", label: <a href="/deliveries">{t("Доставки SIM-карт")}</a> },
        { key: "/tariffs", label: <a href="/tariffs">{t("Тарифы")}</a> },
        { key: "/support", label: <a href="/support">{t("Поддержка")}</a> },
        { key: "/logout", label: <a href="/logout">{t("Выйти")}</a> }
    ])
    : [
        { key: "/bezlimit-ru", label: <a href="/bezlimit-ru">{t("Сайт Безлимит")}</a> },
        {
            key: "menu-store",
            label: (
                <LabelMenuRoute
                    click={click}
                    selectedItem={selectedItem}
                    header={"Приложение Store"}
                    arrayLabelAndRouteFromTo={[0, 2]}
                />
            )
        },
        { key: "https://bezlimit.ru/blog/", label: <a href="https://bezlimit.ru/blog/" target="_blank" rel="noopener noreferrer">{t("Блог")}</a> },
        {
            key: "menu-social",
            label: (
                <LabelMenuRoute
                    click={click}
                    selectedItem={selectedItem}
                    header={"Социальные сети"}
                    arrayLabelAndRouteFromTo={[2, 7]}
                />
            )
        },
        { key: "/logout", label: <a href="/logout">{t("Выйти")}</a> }
    ];

        return (
            <Typography as="div" className="bl-menu sidebar">
                <div className="bl-menu--wrapper">
                    <Icon
                        name={"close"}
                        size={"26px"}
                        className={"sidebar-close"}
                        onClick={toggle}
                    />
                    <Row justify="space-between" className="bl-menu__dealer-service">
                        <Col
                            onClick={() => handleSwitchDealerOrService("dealer")}
                            className="bl-menu__dealer-service__dealer"
                        >
                            {t("Кабинет дилера ")}
                        </Col>
                        <Col
                            onClick={() => handleSwitchDealerOrService("service")}
                            className="bl-menu__dealer-service__service"
                        >
                            {t(" Все сервисы")}
                        </Col>
                    </Row>
                    <Typography as="div" className="links">
                        <MenuAntd
                            mode="inline"
                            defaultSelectedKeys={["/"]}
                            onClick={click}
                            selectedKeys={[selectedItem]}
                            items={[...(Store.user.token ? menuItems : [])]}
                        />
                    </Typography>
                </div>
                <img src={process.env.PUBLIC_URL + "/logo.png"} alt="" className={"sidebar-logo"} />
            </Typography>
        );
    })
);

interface IProps {
    toggle: () => void;
}
